<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">申请臻享合伙人</h1>
      <p class="hint">须先完成实名认证。审核通过后可设置臻享礼券并享有客户终身分润。</p>

      <el-alert v-if="status" :type="statusType" :closable="false" class="status-alert">
        当前状态：<strong>{{ statusLabel }}</strong>
        <span v-if="status.adminReply"> — {{ status.adminReply }}</span>
      </el-alert>

      <el-card v-if="canApply" shadow="never">
        <el-form label-width="100px" @submit.prevent="submit">
          <el-form-item label="真实姓名" required>
            <el-input v-model="form.realName" maxlength="32" />
          </el-form-item>
          <el-form-item label="身份证号" required>
            <el-input v-model="form.idCardNo" maxlength="18" />
          </el-form-item>
          <el-form-item label="联系电话" required>
            <el-input v-model="form.phone" maxlength="20" />
          </el-form-item>
          <el-form-item label="申请说明">
            <el-input v-model="form.intro" type="textarea" :rows="3" maxlength="500" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="submitting" @click="submit">提交申请</el-button>
            <el-button @click="$router.push('/referral/earnings')">查看推荐收益</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { fetchPartnerApplyStatus, submitPartnerApply, PARTNER_STATUS_LABELS } from '@/utils/userHub'

export default {
  name: 'PartnerApplyView',
  data() {
    return {
      status: null,
      submitting: false,
      form: { realName: '', idCardNo: '', phone: '', intro: '' }
    }
  },
  computed: {
    statusLabel() {
      return PARTNER_STATUS_LABELS[this.status?.status] || this.status?.status || '—'
    },
    statusType() {
      const m = { pending: 'warning', approved: 'success', rejected: 'error' }
      return m[this.status?.status] || 'info'
    },
    canApply() {
      return !this.status || this.status.status === 'rejected'
    }
  },
  created() {
    this.loadStatus()
  },
  methods: {
    async loadStatus() {
      try {
        this.status = await fetchPartnerApplyStatus()
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      }
    },
    async submit() {
      this.submitting = true
      try {
        this.status = await submitPartnerApply(this.form)
        this.$message.success('申请已提交，请等待审核')
      } catch (e) {
        this.$message.error(e.message || '提交失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.hint { color: #666; margin-bottom: 16px; }
.status-alert { margin-bottom: 16px; }
</style>
